import { Navigate, useLocation } from 'react-router-dom';

/**
 * Campaigns and Templates are one workspace at `/home/campaigns` now, with the
 * tab in `?tab=`. The old `/home/new-campaigns` and `/home/new-templates`
 * paths redirect here so existing deep links — a campaign from a notification,
 * a template from campaign details, the product tour — keep working, query and
 * all.
 */
export default function MarketingLegacyRedirect() {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);

  if (pathname.startsWith('/home/new-templates')) params.set('tab', 'templates');

  const query = params.toString();
  return <Navigate to={query ? `/home/campaigns?${query}` : '/home/campaigns'} replace />;
}
